import { type ContentComponent, type EmailSubscribeFormPlaceholderContent } from '../../../../types/construct.types';
import { EmailSignUpForm } from '../../../email-sign-up-form/email-sign-up-form.component';

export const EmailSubscribePlaceholder: ContentComponent<EmailSubscribeFormPlaceholderContent> = () => (
	<div className="pa5">
		<EmailSignUpForm />
	</div>
);
